import React from "react";
import { useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

// Svg
import PartyPapper from "../../../../Assets/Svg/Auth/PartyPapper.svg";

// Custom components
import FooterColorLine from "Components/FooterColorLine";
import Button from "Components/Button";

const AssessmentBacklogSuccess = () => {
  // Initialize useNavigate
  const navigate = useNavigate();

  return (
    <>
      <div className="assessment-backlog-success-root-container">
        <img src={PartyPapper} alt="Party Popper" />
        <p className="assessment-backlog-success-text">SUCCESS!</p>
        <p className="assessment-backlog-message-text">
        Emails have been sent successfully to company users.
        </p>
        <Button
          title="Back to Homepage"
          buttonStyle={{ width: "30%" }}
          onClick={() => navigate("/assessment-backlogs", { replace: true })}
        />
      </div>
      <div className="assessment-backlog-footer">
        <FooterColorLine />
      </div>
    </>
  );
};

export default AssessmentBacklogSuccess;
